/**
 * PageLayout Component
 * 
 * Wrapper component providing consistent page structure with
 * Navigation, Footer, and main content area.
 */

import { ReactNode } from "react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";

interface PageLayoutProps {
  children: ReactNode;
  /** Additional classes for the main content container */
  mainClassName?: string;
  /** Whether to include bottom padding for mobile CTA bar */
  withMobileCTAPadding?: boolean;
}

export const PageLayout = ({ 
  children, 
  mainClassName = "",
  withMobileCTAPadding = false 
}: PageLayoutProps) => {
  return (
    <div className={`min-h-screen-safe bg-background ${withMobileCTAPadding ? 'pb-20 md:pb-0' : ''}`}>
      <Navigation />
      <main id="main-content" className={mainClassName}>
        {children}
      </main>
      <Footer />
    </div>
  );
};
